module.exports = __webpack_public_path__ + "static/media/curvit-features.50adfcb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/curvit-features.png
// module id = 189
// module chunks = 0